/**
 * airtec-tracking.js
 * Globales Tracking für Airtec B2B Shop (shop.airtec-energie.ch)
 * GTM Container: GTM-NJHS5CVZ
 *
 * Trackt:
 *  - Telefon-Link Klicks (tel:)
 *  - E-Mail-Link Klicks (mailto:)
 */

document.addEventListener('DOMContentLoaded', function () {
  var dl = window.dataLayer = window.dataLayer || [];

  // ── 1. Telefon-Link Tracking ──────────────────────────────────────────────
  document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var phoneNumber = this.href.replace('tel:', '').trim();
      dl.push({
        event: 'phone_click',
        phone_number: phoneNumber,
        click_text: this.innerText.trim()
      });
    });
  });

  // ── 2. E-Mail-Link Tracking ───────────────────────────────────────────────
  document.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var email = this.href.replace('mailto:', '').split('?')[0].trim();
      dl.push({
        event: 'email_click',
        email_address: email,
        click_text: this.innerText.trim()
      });
    });
  });

});
